import { createContext, useCallback, useContext, useEffect, useState } from "react";

/**
 * Global on-screen keyboard state.
 *
 * Lives at the app root so any page can toggle the same singleton
 * keyboard. The keyboard itself is mounted once in `Layout.jsx`.
 *
 * Preference persists in localStorage so a tablet operator gets the
 * same UX after every refresh.
 */
const KeyboardContext = createContext({
  open: false,
  toggle: () => {},
  setOpen: () => {},
});

export function KeyboardProvider({ children }) {
  const [open, setOpen] = useState(() => {
    try {
      return localStorage.getItem("vk_open") === "1";
    } catch {
      return false;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem("vk_open", open ? "1" : "0");
    } catch {
      /* noop */
    }
  }, [open]);
  const toggle = useCallback(() => setOpen((o) => !o), []);
  return (
    <KeyboardContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </KeyboardContext.Provider>
  );
}

export function useKeyboard() {
  return useContext(KeyboardContext);
}
